import NestedMenu from "components/Shared/NestedMenu";
import React from "react";
import DownloadTMSVendorCard from "components/Shared/UI/DownloadTMSVendorCard";

const VendorSidebar = () => {

      const API_INTREGRATION = [
    {
      title: "Integration",
      icon: "IntegrationInstructionsOutlined",
      subMenus: [
        {
          title: "API Integration",
          path: "/app/vendor/integration/api-credential",
          icon: "CodeOutlined",
        },
          {
          title: "API Documentation",
          path: "/app/vendor/integration/api-documentations",
          icon: "CodeOutlined",
        },
      ],
    },
  ];

  const menuItems = [
    {
      title: "Dashboard",
      path: "/app/vendor/dashboard",
      icon: "DashboardOutlined",
    },
    {
      title: "Profile",
      path: "/app/vendor/profile",
      icon: "GroupOutlined",
    },
    {
      title: "Shipments",
      path: "/app/vendor/shipment/list",
      icon: "GroupWorkOutlined",
    },
    {
      title: "Payments",
      icon: "Payments",
      subMenus: [
        {
          title: "COD Transfer",
          path: "/app/vendor/cod-transfer/list",
          icon: "SwapHorizOutlined",
        },
        {
          title: "Counter Collection",
          path: "/app/vendor/counter-collection/list",
          icon: "SwapHorizOutlined",
        },
        {
          title: "Delivery Collection",
          path: "/app/vendor/delivery-collection/list",
          icon: "LocalShippingOutlined",
        },
        {
          title: "MY Payment Details",
          path: "/app/vendor/payment-details",
          icon: "PaymentOutlined",
        },
        // {
        //   title: "Prepayment",
        //   path: "/app/vendor/prepayment/list",
        //   icon: "RotateRightOutlined",
        // },
        // {
        //   title: "Adjustment",
        //   path: "/app/vendor/adjustment/list",
        //   icon: "BuildCircleOutlined",
        // },
        // {
        //   title: "Payment Account",
        //   path: "/app/vendor/payment-account/list",
        //   icon: "AccountBalanceWalletOutlined",
        // },
      ],
    },

    {
      title: "Branch",
      path: "/app/vendor/branch/list",
      icon: "StorefrontOutlined",
    },

    {
      title: "Tickets",
      icon: "ConfirmationNumberOutlined",
      path: "/app/vendor/ticket/list",
    },
    ...API_INTREGRATION,
    {
      title: "Staffs",
      path: "/app/vendor/staffs/list",
      icon: "Group",
    },
    {
      title: "Announcement",
      path: "/app/vendor/announcement/list",
      icon: "CampaignOutlined",
    },
  ];



  return (
    <>
      <NestedMenu menu={menuItems} initiallyOpenedMenu="Vendor Management" />
      <DownloadTMSVendorCard />
    </>
  );
};

export default VendorSidebar;
